import { render, staticRenderFns } from "./riskInfo.vue?vue&type=template&id=699b445b&scoped=true"
import script from "./riskInfo.vue?vue&type=script&lang=js"
export * from "./riskInfo.vue?vue&type=script&lang=js"
import style0 from "./riskInfo.vue?vue&type=style&index=0&id=699b445b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699b445b",
  null
  
)

export default component.exports